/* app/js/src/components/tenant/tenant.component.scss */
:host {
  display: flex;
  flex: 1;
}
/*# sourceMappingURL=tenant.component.css.map */
